import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { DmsCallService } from 'src/app/services/dms-call.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  Year?: number;
  compName: any
  companyName: any;
  address: any
chunkedLinks: { key: string, value: string }[][] = [];

  constructor(
    private commonService: CommonService,
    private dmsCallService: DmsCallService
  ) { }

  ngOnInit() {
    this.Year = new Date().getFullYear();
    this.getSubdomain()
    this.getnav()
  }
  getSubdomain() {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');

    // Special case: localhost
    if (hostname === "localhost") {
      this.companyName = "kanbiosys";
      return this.companyName;
    }

    // If there are more than 2 parts, first part is subdomain
    if (parts.length > 2) {
      this.companyName = parts[0];
      return this.companyName;
    }

    // No subdomain
    this.companyName = null;
    return this.companyName;
  }

// chunkedLinks: { key: string; value: string }[][] = [];

getnav() {
  const param = {};
  const head = { BPCode: "", CompanyID: "", auth_Control: "", companyName: this.companyName };
  const dataObj = { param, head };

  this.dmsCallService.getHomeData(dataObj).subscribe({
    next: (result: any) => {
      this.address = result.address;
      this.compName = result.compName;

      const links = JSON.parse(result.usefullLinks);

      const linksArray = Object.entries(links).map(([key, value]) => ({
        key,
        value: value as string
      }));

      // Split into chunks of 5
      const chunkSize = 5;
      this.chunkedLinks = [];
      for (let i = 0; i < linksArray.length; i += chunkSize) {
        this.chunkedLinks.push(linksArray.slice(i, i + chunkSize));
      }

      console.log("chunkedLinks:", this.chunkedLinks);
    },
    error: (error: any) => {
      this.commonService.showError(error);
    }
  });
}


}
